import { useMemo } from 'react';

import HighchartsReact from 'highcharts-react-official';
import { useTranslation } from 'react-i18next';

import { CalculatedWorkDemand } from 'components/types';

import getHighchartsInstance from 'utils/charts';
import { getLocalizedMonthNames } from 'utils/date';

import { formatTotalWorkDemandForGraph } from '../../util';

type Props = {
  isShowHours: boolean;
  totalWorkDemand: CalculatedWorkDemand | null;
};

const WorkDemandTotalsGraph = ({ totalWorkDemand, isShowHours }: Props) => {
  const { t } = useTranslation('common');

  const series = useMemo(() => {
    if (totalWorkDemand) {
      return formatTotalWorkDemandForGraph(totalWorkDemand, isShowHours, t);
    }
    return null;
  }, [totalWorkDemand, isShowHours, t]);

  const options = {
    title: {
      text: undefined
    },
    chart: {
      type: 'column'
    },
    xAxis: {
      categories: getLocalizedMonthNames()
    },
    yAxis: {
      title: {
        text: t('hours')
      },
      min: 0,
      allowDecimals: true
    },
    series,
    credits: {
      enabled: false
    }
  };

  const Highcharts = getHighchartsInstance();

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default WorkDemandTotalsGraph;
